
// 导入组件，组件必须声明 name
import VueZzqKeyboard from './VueDusionKeyboard.vue'

// 为组件添加 install 方法，用于按需引入
// VueZzqKeyboard.install = function (Vue) {
//     Vue.component(VueZzqKeyboard.name, VueZzqKeyboard)
// }

export default VueZzqKeyboard